import React from 'react';
import {useDialogueContext} from "../hooks/useDialogueContext.mjs";
import ContactForm from "./ContactForm";

const componentClass = 'contactFormPage';

const ContactFormPage = ({ onComplete }) => {
    const { contactPageIsClosable, updateContactPageState } = useDialogueContext();

    const onClose = () => updateContactPageState(false);

    const onFormComplete = result => {
        onComplete && onComplete(result);
        onClose();
    };

    return <div className={componentClass}>
        { contactPageIsClosable && <i className={`ion-md-close-circle-outline ${componentClass}__closeBtn`} onClick={onClose} /> }
        <ContactForm componentClass={componentClass} onComplete={onFormComplete} />
    </div>;
};

export default ContactFormPage;
